module.exports = __webpack_public_path__ + "img/logo_blue.4fed36c9.png";